import moment from 'moment';
import _ from 'underscore';

class DateUtilsService {
  /**
   * @desc Takes a date and creates a new UTC moment from it at 6AM, ignoring the time on the date passed in
   * @param {Date|Moment}
   * @return Moment
   */
  toUTCMomentWithoutTime(date) { //eslint-disable-line
    if (!date) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date is required');
    if (!_.isDate(date) && !moment.isMoment(date)) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date must be a Date object or a Moment object');

    return moment.isMoment(date) ?
      moment.utc([date.get('year'), date.get('month'), date.get('date'), 6]) :
      moment.utc([date.getFullYear(), date.getMonth(), date.getDate(), 6]);
  }

  /**
   * @desc Takes a date and creates a new UTC unix timestamp from it at 6AM, ignoring the time on the date passed in
   * @param {Date|Moment}
   * @return Number - date in milliseconds
   */
  toUTCTimestampWithoutTime(date) { //eslint-disable-line
    if (!date) throw new Error('dateUtilsService - toUTCTimestampWithoutTime() - date is required');
    if (!_.isDate(date) && !moment.isMoment(date)) throw new Error('dateUtilsService - toUTCTimestampWithoutTime() - date must be a Date object or a Moment object');

    return moment.isMoment(date) ?
      Date.UTC(date.get('year'), date.get('month'), date.get('date'), 6) :
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 6);
  }

  /**
   * @desc Takes a date and creates a new UTC unix timestamp from it, including time from the date passed in
   * @param {Date|Moment}
   * @return Number - date in milliseconds
   */
  toUTCTimestampWithTime(date) { //eslint-disable-line
    if (!date) throw new Error('dateUtilsService - toUTCTimestampWithTime() - date is required');
    if (!_.isDate(date) && !moment.isMoment(date)) throw new Error('dateUtilsService - toUTCTimestampWithTime() - date must be a Date object or a Moment object');

    return moment.isMoment(date) ?
      Date.UTC(date.get('year'), date.get('month'), date.get('date'), date.get('hour'), date.get('minute'), date.get('second'), date.get('millisecond')) :
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
  }
}

export default DateUtilsService;



// WEBPACK FOOTER //
// ./src/services/dateUtilsService.js